import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { SharingResultInput, SharingResultResponse } from '../models/sharings';

/**
 * <p>
 * API endpoints that cover all sharing result related CRUD calls
 */

export const SharingResultInputApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchSharingResultBy: builder.query<PaginationResponse<SharingResultResponse>, SharingResultInput>({
      query: (input: SharingResultInput) => ({
        url: encodeURI(
          `/indirect/sharing-result/searchBy?period=${input.period}&destiniProjectSearchTerm=${input.destiniProjectSearchTerm}&originProjectSearchTerm=${input.originProjectSearchTerm}&personSearchTerm=${input.personSearchTerm}&page=${input.page}&size=${input.size}`,
        ),
      }),
      providesTags: ['SharingResult'],
    }),
    startSharingProcess: builder.mutation<void, string>({
      query: (period: string) => ({
        url: encodeURI(`/indirect/sharing-result/start?period=${period}`),
        method: 'POST',
      }),
      invalidatesTags: ['SharingResult', 'Sharing', 'SharingUnified', 'Periods'],
    }),
    uploadHistoricFile: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: encodeURI(`/indirect/sharing-result/uploadHistoric`),
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['SharingResult'],
    }),
  }),
});

export const { useSearchSharingResultByQuery, useStartSharingProcessMutation, useUploadHistoricFileMutation } =
  SharingResultInputApi;
